import { useMemo } from "react";
import { useGetBusinessUsers } from "@/user/query";
import { buildStAdjustmentsPreviewData } from "./preview-data";

export const useStAdjustmentsPreview = (
  businessId: string | null,
  enabled: boolean,
) => {
  const usersQuery = useGetBusinessUsers(businessId, {
    enabled: !!businessId && enabled,
  });
  const preview = useMemo(
    () => buildStAdjustmentsPreviewData(usersQuery.data),
    [usersQuery.data],
  );
  return {
    data: preview.summary,
    technicianNames: preview.technicianNames,
    isLoading: usersQuery.isLoading,
    error: usersQuery.error,
  };
};
